import styled from '@emotion/styled';
import { UpscTopicInstaLink } from './upscCurrentAffairsTopicTypes';

const isSafeHttpUrl = (url: string) => /^https?:\/\//i.test(url.trim());

const openInstaLink = (link?: string) => {
  if (!link || !isSafeHttpUrl(link)) {
    return;
  }

  window.open(link.trim(), '_blank', 'noopener,noreferrer');
};

const InstaLinksWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

const InstaLink = styled.button`
  padding: 5px 11px;
  border: 1px solid var(--color-i-blue-11);
  border-radius: 20px;
  font-family: inherit;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  background: var(--color-i-blue-11);
  color: var(--color-accent-blue);
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;

  &:hover {
    border-color: var(--color-accent-blue);
    background: var(--color-accent-blue);
    color: var(--color-i-white);
  }
`;

export interface UpscTopicCardInstaLinksProps {
  links: UpscTopicInstaLink[];
}

const UpscTopicCardInstaLinks = ({ links }: UpscTopicCardInstaLinksProps) => (
  <InstaLinksWrap>
    {links.map((linkItem) => (
      <InstaLink
        key={linkItem.label}
        type="button"
        onClick={() => openInstaLink(linkItem.link)}
      >
        {linkItem.label}
      </InstaLink>
    ))}
  </InstaLinksWrap>
);

export default UpscTopicCardInstaLinks;
